/**
 * Encrypts a value for secure use in URL parameters
 * @param {string} value - The original value to encrypt
 * @returns {string} The encrypted value
 */
export const encryptUrlParam = (value: string) => {
  // Use environment variable with fallback for consistency
  const secretKey = process.env.REACT_APP_ENCRYPT_KEY || 'genio-secure-key-fallback';

  // Create a base64 encoded string from value + secretKey
  const encrypted = Buffer.from(value + secretKey)
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

  return encrypted;
};

/**
 * Decrypts an encrypted URL parameter value
 * @param {string} encryptedValue - The encrypted value to decrypt
 * @returns {string|null} The original value or null if decryption fails
 */
export const decryptUrlParam = (encryptedValue: string) => {
  try {
    // Restore base64 standard characters
    const base64 = encryptedValue.replace(/-/g, '+').replace(/_/g, '/');

    // Add padding if needed
    const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');

    const secretKey = process.env.REACT_APP_ENCRYPT_KEY || 'genio-secure-key-fallback';
    const decoded = Buffer.from(paddedBase64, 'base64').toString();

    // Remove the secret key from the end
    if (decoded.endsWith(secretKey)) {
      return decoded.slice(0, -secretKey.length);
    }
    return null;
  } catch (error) {
    // console.error('Failed to decrypt value:', error);
    return null;
  }
};
